import React, {useEffect, useState} from "react";
import {
    Card,
    Page,
    Layout,
    Button,
    Badge,
    ButtonGroup,
    InlineStack, Link
} from "@shopify/polaris";
import Alert from "../Lib/Alert";
import Http from "../Lib/Http";
import {useGoTo} from "@admin/Lib/useGoTo";
import Menu from "@admin/Lib/Menu";
import CriticalError from "@admin/components/CriticalError";

function ShopApp() {
    const [hasMini, setHasMini] = useState(false);
    const [loading, setLoading] = useState(false);
    const btnText = hasMini ? 'Deactivate Size Guides in Shop' : 'Activate Size Guides in Shop';
    const goTo = useGoTo();
    const [error, setError] = useState(false);



    useEffect(() => {
        getShops();
    }, []);



    const openSupport = () => {
        window.open('mailto:support@eastsideco.com', '_blank');
    };


    const getShops = () => {

        Http.get(`/app/api/v1/shop.json`)
            .then((response) => {
             console.log(response.data);
                let shop = response.data.shop

                if(shop.has_shop_mini == 1) {
                    setHasMini(true)
                }

                Menu.loadMenu(shop);

            })
            .catch((error) => {
                console.error('Error fetching data:', error);
            });
    };


    const toggleShop = () => {
        setError(false)
        Http.post(`/app/api/v1/miniapp`, {'hasMini': !hasMini})
            .then(res => {
                 setHasMini(!hasMini);
                Alert.success('Shop app saved')
            }).catch(e => {
            setError(true);
        });
    };




    return (
        <Page title="Shop App" backAction={{content: 'Home', onAction() {goTo('')}}}>
            {error &&
                <Layout>
                    <Layout.Section>
                        <CriticalError  onDismiss={() => {setError(false)}}  showAlert={error} title={'Failed to change Shop app setting'} />
                    </Layout.Section>
                </Layout>
            }
            <Layout>
                <Layout.Section>
                    <Card roundedAbove="sm">
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <div style={{ width: '65%' }}>

                                <div style={{ width: '100%' }}>
                                    <img style={{ width: '55px', float: 'left', marginRight: '10px' }}
                                         src="https://size-guides.esc-apps-cdn.com/shop_logo.webp" />
                                    {hasMini ? <Badge tone="success">Active</Badge> : <Badge>Not Active</Badge>}
                                </div>
                                <div style={{ width: '100%' }}>
                                    &nbsp;
                                </div>
                                <div style={{width: '100%'}}>
                                    <p>
                                        Shop is a shopping destination and delivery tracking app that's available to
                                        customers
                                        on iOS and Android.
                                    </p>
                                    <p>
                                        <br/>
                                        Activate size charts and size guides on your product pages in Shop with one
                                        click.
                                        Shop will use the size guides you have created, making your buyers' experience
                                        better
                                        and reducing your return rates. &nbsp;
                                        <Link target="_blank" url="https://www.shopify.com/shop">Learn more about shop</Link>.


                                    <br/>
                                    <br/>


                                </p>
                            </div>
                            <InlineStack align="end">
                                <ButtonGroup>
                                <Button variant={hasMini ? undefined : "primary"} onClick={toggleShop}
                                                accessibilityLabel="open Supportr">
                                            {btnText}
                                        </Button>
                                    </ButtonGroup>
                                </InlineStack>
                            </div>

                            <div style={{width: '30%'}}>
                                <img style={{width: '100%'}}
                                     src="https://size-guides.esc-apps-cdn.com/shop_mini_mockup.webp"/>
                            </div>
                        </div>
                    </Card>

                </Layout.Section>
            </Layout>
        </Page>
    );
}

export default ShopApp;
